import { Inject } from '@angular/core';
import { AccommodationTableLabels } from '../models/types';
import { getAccommodationsLabels } from '../utils/table-utils';
import { BasePriceListBandsService } from './base-pricelist-bands.service';
import { PriceListAccommodation, PriceListAccommodationOption } from '../models/pricelist-accommodation.model';
import { CompanyEnum } from '../models/company.model';

@Inject({
  providedIn: 'root',
})
export class PriceListAccommodationBandsService extends BasePriceListBandsService<PriceListAccommodationOption> {
  /**
   * Returns the column labels for the accommodation table.
   * Example:
   * [
   *   { band: '1-1', header: '1 week', subHeader: 'Total price' },
   *   { band: '2-3', header: '2-3 weeks', subHeader: 'Per week' },
   *   { band: '8-99', header: '8+ weeks', subHeader: 'Per week' },
   * ]
   */
  getColumnLabels(accommodations: PriceListAccommodation): AccommodationTableLabels {
    const bands = this.getSortedBands(accommodations.products.flatMap(({ options }) => options));
    const headerColumns = this.getHeaderColumnsWithBands(
      bands,
      {
        singular: 'week',
        plural: 'weeks',
      },
      {
        perUnitLabel: 'Per week',
        totalPriceLabel: 'Total price',
      },
    );

    return {
      ...getAccommodationsLabels(CompanyEnum.ALP),
      weeks: headerColumns,
    };
  }
}
